<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Merge Users</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form :method="method" :action="url" @submitted="$emit('changed', $event)">
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-user-search
                  name="user_id"
                  label="Select the user to merge with"
                  item_name="full_name"
                  item_value="id"
                  icon="mdi-account-search"
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  Merge
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    user: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      key: 1,
    };
  },

  computed: {
    url() {
      return `api/v1/users/clients/merge/${this.user.id}`;
    },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
  },
};
</script>
